import type { BucketKind } from "@/types";

interface Props {
  target: BucketKind;
}

const TRAY_WITH_ARROW_DOWN =
  "M8 4H6a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-2m-4-1v8m0 0l3-3m-3 3L9 8m-5 5h2.586a1 1 0 01.707.293l2.414 2.414a1 1 0 00.707.293h3.172a1 1 0 00.707-.293l2.414-2.414a1 1 0 01.707-.293H20";
const TRAY =
  "M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4";

export default function BucketMoveIcon({ target }: Props) {
  return (
    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true" data-icon={`move-to-${target}`}>
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={target === "inbox" ? TRAY_WITH_ARROW_DOWN : TRAY} />
    </svg>
  );
}
